import { useContext } from 'react';

import DrawerContext from './DrawerContext';

export default function useDrawerContext() {
  return useContext(DrawerContext);
}
